import {
    FETCH_ASSETTRANSACTIONS_BEGIN,
    FETCH_ASSETTRANSACTIONS_SUCCESS,
    FETCH_ASSETTRANSACTIONS_FAILURE,
    FETCH_TRANSACTIONSMENULIST_BEGIN,
    FETCH_TRANSACTIONSMENULIST_SUCCESS,
    FETCH_TRANSACTIONSMENULIST_FAILURE
  } from '../constants/transactions';


const initialState={
    transactionList:[],
    transactionMenuList:[],
    isLoading:false,
    error:""
}


export const getTransactionListReducer = (state=initialState,action) => {
    const {type,payload}=action;
 switch(type)
 {
    case FETCH_ASSETTRANSACTIONS_BEGIN: {
        return {
          ...state,
          isLoading: true,
          error: null,
        };
      }
    case FETCH_ASSETTRANSACTIONS_FAILURE:
        return {
            ...state,
            isLoading:false,
            transactionList:null
        };
    case FETCH_ASSETTRANSACTIONS_SUCCESS:
        return {
            ...state,
            transactionList:payload.transactionList,
            isLoading:true,
        };
    case FETCH_TRANSACTIONSMENULIST_BEGIN: {
        return {
            ...state,
            isLoading: true,
            error: null,
        };
        }
    case FETCH_TRANSACTIONSMENULIST_FAILURE:
        return {
            ...state,
            isLoading:false,
            transactionMenuList:null
        };
    case FETCH_TRANSACTIONSMENULIST_SUCCESS:
        return {
            ...state,
            transactionMenuList:payload.transactionMenuList,
            isLoading:true,
        };
    default:
        return state;
 }
}

export default getTransactionListReducer
